import React from 'react';

import achIcon from './assets/ach.png';

interface IconProps {
    className?: string;
}

const iconStyle: React.CSSProperties = {
    borderRadius: 4,
    backgroundColor: 'white',
    border: '1px solid #e5e7eb',
    width: 40
};

export const AchIcon: React.FC<IconProps> = () => {
    return (
        <img
            src={achIcon}
            alt="ACH"
            style={{
                ...iconStyle,
                width: 40,
                objectFit: 'cover'
            }}
        />
    );
};

export const CreditCardIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            style={iconStyle}
            viewBox="0 0 120 80"
            fill="none"
        >
            <rect
                width="120"
                height="80"
                rx="4"
                fill="url(#paint0_linear_823_812)"
            />
            <path
                d="M97.0264 65H83.0264"
                stroke="white"
                strokeWidth="4"
                strokeLinecap="round"
            />
            <path
                d="M75.853 65H61.853"
                stroke="white"
                strokeWidth="4"
                strokeLinecap="round"
            />
            <path
                d="M54.6797 65H40.6797"
                stroke="white"
                strokeWidth="4"
                strokeLinecap="round"
            />
            <path
                d="M33.5063 65H19.5063"
                stroke="white"
                strokeWidth="4"
                strokeLinecap="round"
            />
            <path
                d="M32.173 23.9866H18.8396C15.8941 23.9866 13.5063 26.3744 13.5063 29.3199V38.6533C13.5063 41.5988 15.8941 43.9866 18.8396 43.9866H32.173C35.1185 43.9866 37.5063 41.5988 37.5063 38.6533V29.3199C37.5063 26.3744 35.1185 23.9866 32.173 23.9866Z"
                fill="#EDEDED"
            />
            <path
                d="M22.5198 24.9999V42.9999M22.5198 36.9999H14.5198M36.5198 36.9999H28.5198M22.5198 30.9999H14.5198M36.4931 30.9999H28.2531V43.0533M18.8398 24.6533H32.1731C34.7504 24.6533 36.8398 26.7426 36.8398 29.3199V38.6533C36.8398 41.2306 34.7504 43.3199 32.1731 43.3199H18.8398C16.2624 43.3199 14.1731 41.2306 14.1731 38.6533V29.3199C14.1731 26.7426 16.2624 24.6533 18.8398 24.6533Z"
                stroke="black"
                strokeWidth="1.333"
            />
            <path
                d="M106.493 15H92.4932"
                stroke="#EDEDED"
                strokeWidth="4"
                strokeLinecap="round"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_823_812"
                    x1="34.9333"
                    y1="15.4667"
                    x2="54.9376"
                    y2="59.9923"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#C1C1C1" />
                    <stop offset="1" stopColor="#9F9F9F" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export const VisaIcon: React.FC<IconProps> = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            style={iconStyle}
            viewBox="0 0 120 80"
            fill="none"
        >
            <rect width="120" height="80" rx="4" fill="white" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M86.6666 44.9375L90.3239 35.0625L92.3809 44.9375H86.6666ZM100.952 52.8375L95.8086 27.1625H88.7383C86.3525 27.1625 85.7723 29.0759 85.7723 29.0759L76.1904 52.8375H82.8868L84.2269 49.0244H92.3947L93.1479 52.8375H100.952Z"
                fill="#1434CB"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M77.1866 33.5711L78.0952 28.244C78.0952 28.244 75.2896 27.1625 72.3648 27.1625C69.2031 27.1625 61.6955 28.5638 61.6955 35.3738C61.6955 41.7825 70.5071 41.8621 70.5071 45.2266C70.5071 48.5912 62.6034 47.9901 59.9955 45.8676L59.0476 51.4362C59.0476 51.4362 61.8919 52.8375 66.2397 52.8375C70.5869 52.8375 77.1467 50.5544 77.1467 44.3455C77.1467 37.8964 68.2552 37.296 68.2552 34.4921C68.2552 31.6882 74.4602 32.0484 77.1866 33.5711Z"
                fill="#1434CB"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M54.6517 52.8375H47.6191L52.0144 27.1625H59.0477L54.6517 52.8375Z"
                fill="#1434CB"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M42.3113 27.1625L35.9217 44.8213L35.1663 41.0185L35.167 41.0199L32.9114 29.4749C32.9114 29.4749 32.6394 27.1625 29.7324 27.1625H19.1709L19.0476 27.5966C19.0476 27.5966 22.2782 28.2669 26.057 30.5326L31.8793 52.8375H38.8617L49.5238 27.1625H42.3113Z"
                fill="#1434CB"
            />
        </svg>
    );
};

export const BacsIcon: React.FC<IconProps> = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 40 26"
            style={iconStyle}
        >
            <path d="M0 0h40v26H0z" />
            <g fill="#fff">
                <path d="M0 0v26h40V0zm10.72 9.84.02 2.03-.9.06a9.63 9.63 0 0 0-5.41 1.74c-.92.84-.9 1.73.03 2.73a8.3 8.3 0 0 0 5.8 2.12 5.28 5.28 0 0 0 2.71-.68 5.18 5.18 0 0 0 1.86-1.94 6.82 6.82 0 0 0-.07-5.28A4.8 4.8 0 0 0 11.6 8.2c-.28-.07-.54-.18-.56-.25-.05-.16.97-.07 1.93.18 2.68.68 4.73 2.37 5.24 4.31a4.3 4.3 0 0 1-1.35 4.38 7.22 7.22 0 0 1-2.94 1.84 9.55 9.55 0 0 1-4 .56 8.65 8.65 0 0 1-3.46-.67 6.15 6.15 0 0 1-4.07-4.34c-.51-3.04 2.6-5.93 6.82-6.35.42-.04.92-.07 1.13-.06l.36.01zm23.62.36a.47.47 0 0 1 .03.34c-.04.22-.06.23-.33.16-1.03-.3-2.1.28-1.94 1.05.1.62.65.92 1.58.9l.67-.01v.26c0 .33-.12.38-.91.38-1.56 0-2.47-.75-2.28-1.9a1.47 1.47 0 0 1 .92-1.09 2.02 2.02 0 0 1 1.32-.2 3.01 3.01 0 0 1 .94.11zm3.4.14v.27h-1.1v2.68l-.43-.03-.44-.03-.03-1.31-.03-1.3h-.5c-.49 0-.5 0-.5-.28v-.28h3.03v.28zm-15.89.05a1.38 1.38 0 0 1 .74 1.27 1.27 1.27 0 0 1-.84 1.29c-.45.22-.58.24-1.61.24H19v-3.05l1.26.03c1.07.02 1.3.06 1.58.22zm2.12 1.33v1.56h-.83v-3.12h.83zm3.3-1.4a.7.7 0 0 1 0 1.3c-.16.09-.24.2-.2.23a6.27 6.27 0 0 1 .75 1.35c0 .05-.18.08-.43.06-.41-.03-.44-.05-.76-.58-.3-.5-.37-.55-.67-.58l-.34-.02v1.2h-.83v-3.12h1.09a3 3 0 0 1 1.38.16zm3.68.11v.28h-1.66v.73h1.47v.54l-.7.03-.72.03v.64l.8.03.8.03v.54h-2.47v-3.13h2.48v.28zm-20.21 4.7v3.03l-.34-.06a6.4 6.4 0 0 1-1.88-.79 2.37 2.37 0 0 1-.43-3.99 7.3 7.3 0 0 1 2.54-1.23c.08 0 .11.66.11 3.03zm18.19-.7v.69l.3-.19a1.88 1.88 0 0 1 1.54-.04 1.26 1.26 0 0 1 .55 1.3 1.28 1.28 0 0 1-.71.86 2.2 2.2 0 0 1-1.37-.05c-.23-.18-.31-.18-.31 0 0 .12-.1.14-.44.12l-.44-.03-.02-1.56c-.01-.86 0-1.6.01-1.67.03-.08.22-.12.47-.12h.42zm4.86-.37v.32h-.45c-.45 0-.46 0-.46-.26 0-.35.05-.38.52-.38.4 0 .4 0 .4.32zm-12 .23a1.33 1.33 0 0 1 .8 1.27 1.23 1.23 0 0 1-.72 1.18c-.4.24-.51.26-1.64.29l-1.22.03V14l1.17.03a3.17 3.17 0 0 1 1.62.27zm14.94.18c0 .26.02.28.37.28.33 0 .37.02.37.23 0 .2-.04.23-.37.23h-.37v.58c0 .64.1.8.48.8.22 0 .26.03.26.27v.28h-.56c-.5 0-.59-.03-.83-.27-.25-.25-.26-.32-.26-.96v-.7h-.37c-.33 0-.37-.03-.37-.23 0-.21.04-.23.37-.23.35 0 .37-.02.37-.28s0-.27.45-.27.46 0 .46.27zm-10.7.4a1.08 1.08 0 0 1 .65.9l.06.36h-1.12c-1.01 0-1.11.01-1.08.15.05.28.44.4 1.03.36a5.4 5.4 0 0 0 .77-.11c.19-.06.2-.04.18.2-.02.21-.08.28-.35.33a4.61 4.61 0 0 1-1.78-.02 1.12 1.12 0 0 1-.13-2.1 2.56 2.56 0 0 1 1.77-.06zm7.76 1.08v1.2l-.43-.03-.44-.03-.03-1.18-.02-1.16h.92z" />
                <path d="M19.93 11.58v1.05h.36a1.68 1.68 0 0 0 1.23-.5c.4-.62.01-1.32-.84-1.5-.8-.17-.75-.24-.75.95zm5.69-.51v.46h.32a1.47 1.47 0 0 0 .6-.14c.55-.28.17-.78-.57-.78h-.35zm3.54 4.46a.59.59 0 0 0 .15 1.02.78.78 0 0 0 1-.21.54.54 0 0 0-.01-.8.78.78 0 0 0-1.14-.01zm-9.23-.05v1.01h.39a1.76 1.76 0 0 0 1.25-.53c.38-.7-.3-1.49-1.28-1.49h-.36zm4.74-.11a.6.6 0 0 0-.15.23 1.88 1.88 0 0 0 .69.07 1.78 1.78 0 0 0 .69-.08c0-.36-.95-.52-1.23-.22z" />
            </g>
        </svg>
    );
};

export const MastercardIcon: React.FC<IconProps> = () => {
    return (
        <svg
            style={iconStyle}
            viewBox="0 0 120 80"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="120" height="80" rx="4" fill="white" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M97.5288 54.6562V53.7384H97.289L97.0137 54.3698L96.7378 53.7384H96.498V54.6562H96.6675V53.9637L96.9257 54.5609H97.1011L97.36 53.9624V54.6562H97.5288ZM96.0111 54.6562V53.8947H96.318V53.7397H95.5361V53.8947H95.843V54.6562H96.0111Z"
                fill="#F79E1B"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M49.6521 58.595H70.3479V21.4044H49.6521V58.595Z"
                fill="#FF5F00"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M98.2675 40.0003C98.2675 53.063 87.6791 63.652 74.6171 63.652C69.0996 63.652 64.0229 61.7624 60 58.5956C65.5011 54.2646 69.0339 47.5448 69.0339 40.0003C69.0339 32.4552 65.5011 25.7354 60 21.4044C64.0229 18.2376 69.0996 16.348 74.6171 16.348C87.6791 16.348 98.2675 26.937 98.2675 40.0003Z"
                fill="#F79E1B"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M50.966 40.0003C50.966 32.4552 54.4988 25.7354 59.9999 21.4044C55.977 18.2376 50.9003 16.348 45.3828 16.348C32.3208 16.348 21.7324 26.937 21.7324 40.0003C21.7324 53.063 32.3208 63.652 45.3828 63.652C50.9003 63.652 55.977 61.7624 59.9999 58.5956C54.4988 54.2646 50.966 47.5448 50.966 40.0003Z"
                fill="#EB001B"
            />
        </svg>
    );
};

export const AmexIcon: React.FC<IconProps> = () => {
    return (
        <svg
            style={iconStyle}
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            viewBox="0 0 120 80"
        >
            <rect
                x="40"
                width="80"
                height="80"
                rx="4"
                fill="#fff"
                fillRule="evenodd"
            />
            <path
                d="m120 76v-8.6763h-9.651l-4.969-5.4944-4.994 5.4944h-31.822v-25.607h-10.27l12.74-28.831h12.286l4.3857 9.877v-9.877h15.208l2.64 7.4429 2.658-7.4429h11.789v-8.8854c0-2.2091-1.7909-4-4-4h-112c-2.2091 4.4409e-16 -4 1.7909-4 4v72c4.4409e-16 2.2091 1.7909 4 4 4h112c2.2091 0 4-1.7909 4-4zm-8.026-11.882h8.026l-10.616-11.258 10.616-11.13h-7.898l-6.556 7.1645-6.4935-7.1645h-8.0275l10.554 11.194-10.554 11.194h7.8041l6.5889-7.2283 6.556 7.2283zm1.878-11.249 6.148 6.5406v-13.027l-6.148 6.4861zm-35.78 6.0675v-3.4864h12.633v-5.0534h-12.633v-3.4859h12.953l5e-4 -5.1815h-19.062v22.388h19.062l-5e-4 -5.1813h-12.953zm35.883-20.456h6.045v-22.388h-9.403l-5.022 13.944-4.989-13.944h-9.5631v22.388h6.0446v-15.672l5.7575 15.672h5.373l5.757-15.704v15.704zm-29.809 0h6.8765l-9.8824-22.388h-7.8682l-9.8833 22.388h6.7166l1.8554-4.4776h10.298l1.887 4.4776zm-3.9976-9.4992h-6.0773l3.0387-7.3242 3.0386 7.3242z"
                fill="#0690FF"
            />
        </svg>
    );
};

export const IdealIcon: React.FC<IconProps> = () => {
    return (
        <svg
            style={iconStyle}
            viewBox="0 0 295 295"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <linearGradient id="a">
                <stop offset=".02" stopColor="#1d1c1c" stopOpacity="0" />
                <stop offset=".68" stopColor="#1d1c1c" />
            </linearGradient>
            <linearGradient
                id="b"
                gradientTransform="matrix(1 0 0 -1 0 296)"
                gradientUnits="userSpaceOnUse"
                x1="152.7"
                x2="130.19"
                xlinkHref="#a"
                y1="50.16"
                y2="22.59"
            />
            <linearGradient
                id="c"
                gradientTransform="matrix(1 0 0 -1 0 296)"
                gradientUnits="userSpaceOnUse"
                x1="113.43"
                x2="136.51"
                xlinkHref="#a"
                y1="44.31"
                y2="67.12"
            />
            <rect fill="#fff48d" height="295" rx="13" width="295" />
            <path
                d="m56.51 22.87v136.4c0 6.53 5.37 11.87 11.93 11.87h81.89c61.91 0 88.74-34.49 88.74-80.25s-26.84-79.89-88.75-79.89h-81.89c-6.56 0-11.93 5.34-11.93 11.87z"
                fill="#fff"
            />
            <path
                d="m111.32 44.48v100.79h44.07c40.02 0 57.37-22.5 57.37-54.31s-17.36-54.07-57.37-54.07h-36.44c-4.23 0-7.63 3.44-7.63 7.6z"
                fill="#c06"
            />
            <path
                d="m79.11 160.28h71.21c50.04 0 77.65-24.63 77.65-69.33 0-25.76-10.08-69.03-77.65-69.03h-71.21c-6.32 0-11.45 5.1-11.45 11.4v115.57c0 6.29 5.13 11.4 11.45 11.4zm-7.64-126.96c0-4.21 3.4-7.6 7.63-7.6h71.21c27.55 0 73.83 8.49 73.83 65.23 0 42.26-26.24 65.53-73.83 65.53h-71.21c-4.23 0-7.63-3.38-7.63-7.6z"
                fill="#232323"
                fillRule="evenodd"
            />
            <path
                d="m133.01 76.3c-1.34-.48-2.74-.72-4.26-.72v-.06h-10.09v24.34h10.21c1.81 0 3.38-.36 4.72-.96 1.34-.66 2.45-1.5 3.33-2.58s1.52-2.4 1.98-3.9c.41-1.5.64-3.12.64-4.92 0-2.04-.29-3.78-.82-5.28-.58-1.44-1.34-2.7-2.27-3.72-.99-.96-2.1-1.74-3.44-2.22zm-2.4 18.77c-.76.24-1.46.36-2.22.36v.06h-4.61v-15.35h3.73c1.28 0 2.33.18 3.21.54s1.57.96 2.1 1.62.93 1.56 1.17 2.52c.23.96.35 2.1.35 3.3 0 1.38-.18 2.46-.52 3.42-.35.96-.82 1.68-1.34 2.28-.53.6-1.17 1.02-1.87 1.26z"
                fill="#fff"
                fillRule="evenodd"
            />
            <path
                d="m160.6 75.59v4.5h-12.49v5.22h11.49v4.14h-11.49v5.94h12.78v4.5h-17.97v-24.34h17.68v.06z"
                fill="#fff"
            />
            <path
                d="m187.32 99.93-8.87-24.34h-5.43l-8.93 24.34h5.25l1.87-5.4h8.87l1.81 5.4zm-11.55-18.35 2.98 8.93h-6.13l3.09-8.93z"
                fill="#fff"
                fillRule="evenodd"
            />
            <path
                d="m195.78 75.58v19.85h11.55v4.5h-16.74v-24.34h5.19z"
                fill="#fff"
            />
            <path
                d="m90.84 100.29c6.32 0 11.44-5.12 11.44-11.45s-5.12-11.45-11.44-11.45-11.44 5.12-11.44 11.45 5.12 11.45 11.44 11.45z"
                fill="#232323"
            />
            <path
                d="m97.65 146.08c-8.86 0-15.96-7.65-15.96-17.05v-13.31c0-4.7 3.55-8.56 8.01-8.56s8.01 3.8 8.01 8.56v30.36z"
                fill="#232323"
            />
            <g fill="#1d1c1c">
                <path d="m258 199h-220c-1.1 0-2-.9-2-2s.9-2 2-2h220c1.1 0 2 .9 2 2s-.9 2-2 2z" />
                <path d="m205.58 248.76c0-13.38 9.52-25.57 25.96-25.57s26.03 12.2 26.03 25.57-9.52 25.57-26.03 25.57c-16.44 0-25.96-12.2-25.96-25.57zm37.54 0c0-6.45-4.25-12.4-11.58-12.4s-11.58 5.96-11.58 12.4 4.32 12.41 11.58 12.41 11.58-5.96 11.58-12.41z" />
                <path d="m195.47 258.26c5.48-3.12 8.77-9.08 8.77-15.66 0-9.77-7.06-18.09-18.02-18.09h-23.01v48.51h14.25v-12.4h2.67l8.15 12.4h16.78zm-12.12-8.8h-5.89v-13.72h5.96c3.84 0 6.3 3.12 6.3 6.86s-2.54 6.86-6.37 6.86z" />
                <path d="m98.17 224.46-8.55 28.91-8.34-28.91h-11.35l-8.41 28.91-8.48-28.91h-15.04l17.23 48.42h12.38l8-26.36 7.93 26.36h12.44l17.23-48.42z" />
                <path d="m134.77 261.05h-.04c-5.33 0-9.07-3.22-10.67-7.48h36.21c.29-1.6.44-3.24.44-4.9 0-13.34-9.49-25.51-25.95-25.52v13.14c5.36.01 9.06 3.23 10.65 7.48h-36.16c-.29 1.6-.44 3.24-.44 4.9 0 13.35 9.5 25.53 25.91 25.53h.04v-13.15z" />
            </g>
            <path
                d="m134.73 274.19c.56 0 1.1-.02 1.65-.04 3.33-.17 6.36-.85 9.06-1.94 2.7-1.1 5.07-2.6 7.08-4.42s3.68-3.95 4.97-6.3c1.17-2.13 2.03-4.45 2.57-6.86h-15.09c-.31.64-.67 1.26-1.08 1.83-.56.79-1.22 1.5-1.97 2.11-.75.62-1.59 1.14-2.51 1.54-.93.4-1.93.68-3.02.83-.53.07-1.08.11-1.65.11-3.4 0-6.14-1.31-8.1-3.36l-9.81 9.92c4.36 4.03 10.41 6.57 17.91 6.57z"
                fill="url(#b)"
            />
            <path
                d="m134.73 223.14c-13.92 0-22.87 8.76-25.26 19.56h15.04c1.8-3.72 5.34-6.42 10.22-6.42 3.89 0 6.91 1.68 8.88 4.22l9.9-10.01c-4.42-4.48-10.78-7.35-18.77-7.35z"
                fill="url(#c)"
            />
        </svg>
    );
};

export const TwintIcon: React.FC<IconProps> = () => {
    return (
        <svg
            style={iconStyle}
            viewBox="0 0 120 80"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="120" height="80" rx="4" fill="black" />
            <path
                d="M104.946 34.1879H94.5782V36.6836H98.2862V47.3981H101.22V36.6836H104.946V34.1879Z"
                fill="white"
            />
            <path
                d="M57.8582 34.1879H47.4902V36.6836H51.2162V47.3981H54.1502V36.6836H57.8582V34.1879Z"
                fill="white"
            />
            <path
                d="M87.8642 33.7686C84.6062 33.7686 82.7882 35.8822 82.7882 38.9251V47.3978H85.6862V38.8522C85.6862 37.5221 86.4602 36.5017 87.9002 36.5017C89.3222 36.5017 90.0962 37.7043 90.0962 38.8522V47.3978H92.9942V38.9251C92.9942 35.8822 91.1222 33.7686 87.8642 33.7686Z"
                fill="white"
            />
            <path
                d="M76.9022 34.1879V47.3981H79.8182V34.1879H76.9022Z"
                fill="white"
            />
            <path
                d="M67.0742 39.4349L67.1822 40.0181L69.9002 47.3981H71.0882L74.7962 34.1879H71.9342L70.1522 41.1296L70.0622 41.8766L69.9182 41.1296L67.5422 34.1879H66.6062L64.2482 41.1296L64.1042 41.8766L63.9962 41.1296L62.2322 34.1879H59.3702L63.0782 47.3981H64.2662L66.9842 40.0181L67.0742 39.4349Z"
                fill="white"
            />
            <path
                d="M40.7037 46.8298C40.7037 47.2159 40.4324 47.6939 40.1068 47.8777L28.4756 54.6984C28.15 54.9006 27.6074 54.9006 27.2818 54.6984L15.6506 47.8777C15.325 47.6755 15.0537 47.2159 15.0537 46.8298V33.1702C15.0537 32.7841 15.325 32.3062 15.6506 32.1223L27.2818 25.3017C27.6074 25.0995 28.15 25.0995 28.4756 25.3017L40.1068 32.1223C40.4324 32.3245 40.7037 32.7841 40.7037 33.1702V46.8298Z"
                fill="white"
            />
            <path
                d="M33.9362 39.2611L30.9837 43.4739L29.4633 41.2134L31.2135 38.6788C31.5318 38.2335 32.2389 36.9834 31.4257 35.2879C30.7715 33.9179 29.3572 33.25 28.1196 33.25C26.882 33.25 25.5207 33.8665 24.8135 35.2879C24.0003 36.9149 24.7075 38.1993 25.008 38.6274C25.008 38.6274 25.9804 40.0146 26.7936 41.1791L28.1196 43.0287L30.0997 45.9571C30.1174 45.9743 30.4356 46.4366 30.9837 46.4366C31.5141 46.4366 31.8323 45.9743 31.8854 45.9229L36.5351 39.2611H33.9362ZM28.1196 39.3638C28.1196 39.3638 27.3417 38.2164 26.8467 37.4286C26.2986 36.5723 26.9174 35.3051 28.1196 35.3051C29.3395 35.3051 29.9406 36.5723 29.3925 37.4286C28.8975 38.2335 28.1196 39.3638 28.1196 39.3638V39.3638Z"
                fill="url(#paint0_radial_830_5939)"
            />
            <path
                d="M25.2555 43.3369L22.3384 39.381C22.3384 39.381 21.5605 38.2335 21.0654 37.4458C20.5174 36.5895 21.1361 35.3222 22.3384 35.3222C22.4975 35.3222 22.6389 35.3393 22.7627 35.3736L23.7881 33.5583C23.3107 33.3699 22.8157 33.2672 22.3384 33.2672C21.1008 33.2672 19.7395 33.8837 19.0323 35.3051C18.219 36.932 18.9262 38.2164 19.2268 38.6446L24.3185 45.9572C24.3538 46.0257 24.6897 46.488 25.2201 46.488C25.7682 46.488 26.0687 46.0428 26.1218 45.9743L27.6599 43.7137L26.3339 41.8299L25.2555 43.3369Z"
                fill="url(#paint1_radial_830_5939)"
            />
            <defs>
                <radialGradient
                    id="paint0_radial_830_5939"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(27.1406 34.3137) scale(13.6969)"
                >
                    <stop stopColor="#FFCC00" />
                    <stop offset="0.09157" stopColor="#FFC800" />
                    <stop offset="0.1739" stopColor="#FFBD00" />
                    <stop offset="0.2528" stopColor="#FFAB00" />
                    <stop offset="0.3295" stopColor="#FF9100" />
                    <stop offset="0.4046" stopColor="#FF7000" />
                    <stop offset="0.4786" stopColor="#FF4700" />
                    <stop offset="0.5503" stopColor="#FF1800" />
                    <stop offset="0.5822" stopColor="#FF0000" />
                    <stop offset="1" stopColor="#FF0000" />
                </radialGradient>
                <radialGradient
                    id="paint1_radial_830_5939"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(18.8841 34.5648) scale(12.559 12.559)"
                >
                    <stop stopColor="#00B4E6" />
                    <stop offset="0.201" stopColor="#00B0E3" />
                    <stop offset="0.3898" stopColor="#01A5DB" />
                    <stop offset="0.5737" stopColor="#0292CD" />
                    <stop offset="0.7546" stopColor="#0377BA" />
                    <stop offset="0.9316" stopColor="#0455A1" />
                    <stop offset="1" stopColor="#054696" />
                </radialGradient>
            </defs>
        </svg>
    );
};

export const PaypalIcon: React.FC<IconProps> = () => {
    return (
        <svg
            style={iconStyle}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 120 80"
            fill="none"
        >
            <rect width="120" height="80" rx="4" fill="white" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M76.2315 34.67C75.8559 37.1343 73.9727 37.1343 72.1505 37.1343H71.1141L71.8414 32.5332C71.8848 32.2553 72.1248 32.0508 72.4065 32.0508H72.8822C74.1224 32.0508 75.2934 32.0508 75.8975 32.7563C76.2589 33.1785 76.3679 33.8052 76.2315 34.67ZM75.4387 28.2401H68.5683C68.0979 28.2401 67.6984 28.5818 67.6249 29.0456L64.847 46.6499C64.7921 46.9969 65.0613 47.3112 65.4121 47.3112H68.9377C69.2663 47.3112 69.5462 47.0722 69.5976 46.7482L70.386 41.7567C70.4586 41.2929 70.859 40.9512 71.3285 40.9512H73.5023C78.0279 40.9512 80.6402 38.7631 81.3223 34.4248C81.6297 32.5288 81.3347 31.0382 80.4462 29.9945C79.4692 28.8474 77.7374 28.2401 75.4387 28.2401Z"
                fill="#009CDE"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M27.2281 34.67C26.8525 37.1343 24.9693 37.1343 23.1471 37.1343H22.1107L22.838 32.5332C22.8814 32.2553 23.1214 32.0508 23.4031 32.0508H23.8788C25.119 32.0508 26.29 32.0508 26.8941 32.7563C27.2556 33.1785 27.3645 33.8052 27.2281 34.67ZM26.4353 28.2401H19.5649C19.0945 28.2401 18.695 28.5818 18.6215 29.0456L15.8436 46.6499C15.7887 46.9969 16.0571 47.3112 16.4087 47.3112H19.6898C20.1593 47.3112 20.5588 46.9695 20.6323 46.5065L21.3826 41.7567C21.4552 41.2929 21.8556 40.9512 22.3251 40.9512H24.4989C29.0245 40.9512 31.6368 38.7631 32.3189 34.4248C32.6263 32.5288 32.3313 31.0382 31.4428 29.9945C30.4658 28.8474 28.734 28.2401 26.4353 28.2401Z"
                fill="#003087"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M42.3858 40.9899C42.0678 42.8683 40.5761 44.1296 38.6724 44.1296C37.7184 44.1296 36.954 43.8225 36.4632 43.2418C35.9769 42.6665 35.7935 41.8459 35.9477 40.9333C36.2435 39.0709 37.7601 37.7697 39.6344 37.7697C40.569 37.7697 41.3272 38.0795 41.8277 38.6655C42.3317 39.2559 42.5302 40.0809 42.3858 40.9899ZM46.9708 34.591H43.6808C43.3992 34.591 43.1591 34.7955 43.1148 35.0743L42.9704 35.9931L42.741 35.6603C42.0279 34.6273 40.4396 34.2812 38.854 34.2812C35.2195 34.2812 32.1147 37.0341 31.5106 40.8943C31.1961 42.8205 31.6426 44.6607 32.7357 45.9451C33.7393 47.1251 35.1717 47.6163 36.8787 47.6163C39.8089 47.6163 41.4335 45.7362 41.4335 45.7362L41.2865 46.6497C41.2316 46.9967 41.5 47.311 41.8525 47.311H44.8147C45.2851 47.311 45.6846 46.9702 45.7581 46.5063L47.5368 35.2523C47.5917 34.9053 47.3224 34.591 46.9708 34.591Z"
                fill="#003087"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M91.3887 40.9899C91.0707 42.8683 89.579 44.1296 87.6754 44.1296C86.7213 44.1296 85.9569 43.8225 85.4661 43.2418C84.9789 42.6665 84.7965 41.8459 84.9506 40.9333C85.2465 39.0709 86.763 37.7697 88.6374 37.7697C89.5719 37.7697 90.3302 38.0795 90.8306 38.6655C91.3347 39.2559 91.5331 40.0809 91.3887 40.9899ZM95.9737 34.591H92.6838C92.4021 34.591 92.162 34.7955 92.1177 35.0743L91.9734 35.9931L91.743 35.6603C91.0308 34.6273 89.4426 34.2812 87.857 34.2812C84.2225 34.2812 81.1177 37.0341 80.5135 40.8943C80.1991 42.8205 80.6455 44.6607 81.7386 45.9451C82.7423 47.1251 84.1746 47.6163 85.8816 47.6163C88.8119 47.6163 90.4365 45.7362 90.4365 45.7362L90.2894 46.6497C90.2345 46.9967 90.5029 47.311 90.8555 47.311H93.8176C94.288 47.311 94.6875 46.9702 94.761 46.5063L96.5397 35.2523C96.5947 34.9053 96.3254 34.591 95.9737 34.591Z"
                fill="#009CDE"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M64.4927 34.5911H61.186C60.8697 34.5911 60.5739 34.7478 60.3967 35.0098L55.8347 41.7229L53.9019 35.2718C53.7805 34.8682 53.4085 34.5911 52.9868 34.5911H49.7368C49.3444 34.5911 49.068 34.977 49.1947 35.3479L52.8354 46.0284L49.4108 50.857C49.1424 51.2359 49.4135 51.7599 49.8785 51.7599H53.1817C53.4944 51.7599 53.7876 51.6068 53.9665 51.3501L64.9631 35.4896C65.2262 35.1098 64.9551 34.5911 64.4927 34.5911Z"
                fill="#003087"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M99.8516 28.7239L97.0321 46.6504C96.9771 46.9973 97.2455 47.3116 97.5972 47.3116H100.434C100.903 47.3116 101.303 46.9699 101.376 46.5061L104.157 28.9018C104.212 28.5548 103.943 28.2406 103.591 28.2406H100.418C100.135 28.2406 99.895 28.445 99.8516 28.7239Z"
                fill="#009CDE"
            />
        </svg>
    );
};

export const SepaIcon: React.FC<IconProps> = () => {
    return (
        <svg
            style={iconStyle}
            viewBox="0 0 120 80"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="120" height="80" rx="4" fill="white" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M61.7961 51.0291L61.7626 52.2779H57.8379V46.1184H59.2417V51.0291H61.7961Z"
                fill="#005DA1"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M65.3571 50.1424C65.2336 50.0933 64.9856 50.0354 64.6468 50.0354C64.0768 50.0354 63.8121 50.2573 63.8121 50.6922C63.8121 51.1772 64.1015 51.3499 64.5242 51.3499C64.9609 51.3499 65.3571 51.0868 65.3571 50.7668V50.1424ZM65.5486 51.8015L65.523 51.7928C65.2177 52.1541 64.7386 52.3601 64.1668 52.3601C63.2174 52.3601 62.6147 51.8261 62.6147 50.7089C62.6147 49.789 63.2589 49.1567 64.3989 49.1567C64.7703 49.1567 65.0924 49.2146 65.3571 49.2962V49.0094C65.3571 48.5078 65.0924 48.2781 64.4077 48.2781C63.8545 48.2781 63.4909 48.3605 63.0268 48.549L62.9192 47.5309C63.4247 47.3169 63.9939 47.2021 64.6389 47.2021C66.1177 47.2021 66.6303 47.8343 66.6303 49.1979V52.2777H65.6465L65.5486 51.8015Z"
                fill="#005DA1"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M69.4 52.3767C68.7956 52.3767 68.2503 52.2618 67.8294 52.0321L67.9609 50.9806C68.3756 51.2183 68.9624 51.3332 69.3912 51.3332C69.9038 51.3332 70.1183 51.128 70.1183 50.8324C70.1183 50.0353 67.7968 50.4957 67.7968 48.755C67.7968 47.8597 68.4083 47.2186 69.6974 47.2186C70.2003 47.2186 70.698 47.3177 71.118 47.4896L71.0112 48.5323C70.5974 48.3604 70.0441 48.278 69.6727 48.278C69.2518 48.278 69.0188 48.4428 69.0188 48.6971C69.0188 49.4522 71.3085 49.0006 71.3085 50.7176C71.3085 51.7111 70.7544 52.3767 69.4 52.3767Z"
                fill="#005DA1"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M73.8302 48.2537V50.7994C73.8302 51.1861 74.0287 51.3501 74.4249 51.3501C74.5573 51.3501 74.7302 51.3255 74.822 51.2922L74.8961 52.22C74.7223 52.2945 74.3923 52.3603 74.0358 52.3603C73.037 52.3603 72.549 51.785 72.549 50.8406V48.2537H71.987V47.3013H72.6064L72.8208 46.1754L73.8302 46.085V47.3013H74.9464V48.2537H73.8302Z"
                fill="#005DA1"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M97.9976 52.2778V48.2457H97.3693V47.3013H97.9976V47.0873C97.9976 46.3401 98.5182 45.7245 99.7155 45.7245C99.9979 45.7245 100.31 45.7649 100.526 45.8307L100.451 46.6523C100.302 46.619 100.138 46.6032 99.9714 46.6032C99.4693 46.6032 99.2779 46.7997 99.2779 47.1206V47.3013H100.344V48.2457H99.2779V52.2778H97.9976Z"
                fill="#005DA1"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M94.8401 52.2778V47.3337L96.154 47.2758V52.2778H94.8401ZM95.501 46.7672C95.0051 46.7672 94.766 46.6269 94.766 46.2253C94.766 45.8719 95.0051 45.6746 95.501 45.6746C96.0057 45.6746 96.2281 45.864 96.2281 46.2253C96.2281 46.5866 96.0057 46.7672 95.501 46.7672Z"
                fill="#005DA1"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M90.5345 52.2778V47.3337L91.5581 47.2846L91.6745 48.1142H91.6983C92.0133 47.5143 92.5013 47.2188 93.0713 47.2188C93.2945 47.2188 93.4842 47.2521 93.6157 47.2925L93.5328 48.5491C93.3775 48.5 93.1869 48.4667 92.9875 48.4667C92.3186 48.4667 91.8236 48.9516 91.8236 49.7812V52.2778H90.5345Z"
                fill="#005DA1"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M87.9053 52.2778V49.1077C87.9053 48.5982 87.6494 48.3351 87.1041 48.3351C86.7318 48.3351 86.4097 48.5 86.2527 48.7131V52.2778H84.9715V45.8885L86.2527 45.8228V46.9557L86.2359 47.6126L86.2606 47.6301C86.633 47.317 87.0856 47.2022 87.5091 47.2022C88.5662 47.2022 89.1856 47.909 89.1856 49.1077V52.2778H87.9053Z"
                fill="#005DA1"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M83.6814 48.5161C83.4256 48.4258 83.1194 48.36 82.83 48.36C81.8973 48.36 81.5903 48.7459 81.5903 49.7973C81.5903 50.8654 82.0288 51.2837 82.8053 51.2837C83.1361 51.2837 83.4503 51.2179 83.715 51.0952L83.8067 52.0887C83.5094 52.2694 83.062 52.3764 82.5247 52.3764C81.0458 52.3764 80.2597 51.538 80.2597 49.7973C80.2597 48.1461 80.9461 47.2183 82.5494 47.2183C82.9703 47.2183 83.4423 47.3086 83.7556 47.4323L83.6814 48.5161Z"
                fill="#005DA1"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M77.4249 52.3767C76.8213 52.3767 76.276 52.2618 75.8543 52.0321L75.9866 50.9806C76.4005 51.2183 76.9872 51.3332 77.4169 51.3332C77.9296 51.3332 78.144 51.128 78.144 50.8324C78.144 50.0353 75.8225 50.4957 75.8225 48.755C75.8225 47.8597 76.4331 47.2186 77.7231 47.2186C78.226 47.2186 78.7228 47.3177 79.1437 47.4896L79.0369 48.5323C78.6231 48.3604 78.0699 48.278 77.6984 48.278C77.2766 48.278 77.0446 48.4428 77.0446 48.6971C77.0446 49.4522 79.3343 49.0006 79.3343 50.7176C79.3343 51.7111 78.7802 52.3767 77.4249 52.3767Z"
                fill="#005DA1"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M102.973 48.2537V50.7994C102.973 51.1861 103.171 51.3501 103.567 51.3501C103.699 51.3501 103.873 51.3255 103.964 51.2922L104.038 52.22C103.865 52.2945 103.535 52.3603 103.178 52.3603C102.179 52.3603 101.691 51.785 101.691 50.8406V48.2537H101.128V47.3013H101.748L101.963 46.1754L102.973 46.085V47.3013H104.088V48.2537H102.973Z"
                fill="#005DA1"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M61.9028 42.6681C60.3543 42.6681 58.9311 42.2971 57.7734 41.678L58.1652 39.113C59.3405 39.7321 60.5502 40.0864 61.8667 40.0864C63.3261 40.0864 63.9676 39.5559 63.9676 38.636C63.9676 36.5489 57.8273 37.4328 57.8273 32.993C57.8273 30.7472 59.2867 28.9249 62.6679 28.9249C63.9676 28.9249 65.3731 29.1906 66.4055 29.6151L66.0323 32.1266C64.9284 31.7732 63.8255 31.561 62.8108 31.561C61.1555 31.561 60.7108 32.1266 60.7108 32.8342C60.7108 34.9038 66.8502 33.9488 66.8502 38.4413C66.8502 41.0589 65.0167 42.6681 61.9028 42.6681Z"
                fill="#005DA1"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M78.421 39.8206V42.4207H69.3451V29.1555H78.421V31.7906H72.3531V34.4258H77.2819V36.7961H72.3531V39.8206H78.421Z"
                fill="#005DA1"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M85.8635 31.6491H84.0829V35.7171H85.8635C87.3406 35.7171 87.9803 35.3462 87.9803 33.6835C87.9803 32.0911 87.4121 31.6491 85.8635 31.6491ZM85.8635 38.105H84.0829V42.4212H81.0759V29.1551H85.8635C89.565 29.1551 91.0774 30.6055 91.0774 33.7011C91.0774 36.4958 89.5835 38.105 85.8635 38.105Z"
                fill="#005DA1"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M97.4702 32.7984L96.1352 37.3443H99.5349L98.2528 32.7984L97.8972 31.4014H97.8434L97.4702 32.7984ZM100.246 39.8383H95.4055L94.6581 42.4209H91.4905L96.0999 29.1556H99.6769L104.339 42.4209H100.993L100.246 39.8383Z"
                fill="#005DA1"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M29.6441 39.6275C29.6018 39.6836 29.5374 39.7117 29.4712 39.7257C29.3971 39.7345 29.3203 39.7178 29.2568 39.6705L25.8235 37.1072L21.2291 33.6776L17.795 31.1135C17.7324 31.0661 17.6953 30.9977 17.6821 30.924C17.6777 30.8574 17.6874 30.7881 17.7297 30.732L18.6659 29.4929C18.6659 29.4929 19.6938 28.1714 20.5965 26.9779L24.4603 29.863L28.6462 32.9883L32.5109 35.8734C31.6082 37.0669 30.5803 38.3884 30.5803 38.3884L29.6441 39.6275ZM23.1862 24.0034L26.5991 26.5526L28.9065 28.2749L31.2121 29.998L34.6268 32.5455C34.7582 32.6428 34.7856 32.8261 34.6885 32.9541L33.8697 34.0748L30.0059 31.1897L25.82 28.0644L21.9562 25.1793L22.7741 24.0586C22.8703 23.9306 23.0556 23.906 23.1862 24.0034ZM35.0177 32.0491L29.2868 27.7715L23.5568 23.4921C23.1571 23.1948 22.5906 23.2738 22.2915 23.6693L17.2471 30.3435C17.1668 30.4479 17.1191 30.5636 17.0909 30.6838C17.0044 31.024 17.1244 31.4002 17.4235 31.6247L20.8391 34.1739L25.453 37.6185L28.8668 40.1668C29.1668 40.3913 29.5638 40.4009 29.8682 40.2221C29.9768 40.1633 30.0747 40.0844 30.1541 39.98L35.1985 33.3066C35.4977 32.9111 35.4165 32.3473 35.0177 32.0491Z"
                fill="#A4AAB6"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.4587 56.1126L20.484 42.8281H31.3907L30.451 44.0786L29.0975 45.9368L28.944 46.2113L28.8019 46.5305L28.6563 46.89L28.5046 47.2715L28.359 47.6871L28.2152 48.0958L28.0802 48.507L27.9469 48.9104L27.8269 49.2928L27.7166 49.6453L27.6187 49.9531L27.5446 50.21L27.4872 50.4056L27.4396 50.5275C27.4396 50.5275 27.4316 50.5538 27.4078 50.5854C27.3805 50.6231 27.2155 50.773 27.0813 50.6739C26.9525 50.5783 26.9657 50.2416 26.979 50.0811C27.0196 49.5892 27.0593 49.0972 27.0999 48.6061C27.1122 48.4334 26.9004 48.336 26.7637 48.4141C26.161 48.7587 25.8019 49.1761 25.4728 49.6532C25.5037 49.5418 25.5346 49.4296 25.5646 49.3182C25.704 48.8113 25.899 48.2869 25.974 47.766C26.0163 47.4688 25.9405 47.1154 25.591 47.0584C25.1975 46.9926 24.9399 47.4039 24.7475 47.6748C24.1643 48.4921 23.821 49.5304 23.0975 50.2416C22.8249 50.5091 22.5231 50.7064 22.1322 50.5959C21.6778 50.4678 21.5013 50.9984 22.3025 51.0703C23.0905 51.1404 23.6763 50.3135 24.0337 49.7356C24.2931 49.3156 24.5216 48.8771 24.774 48.4536C24.8957 48.2501 25.0219 48.0493 25.1613 47.8572C25.2222 47.7757 25.336 47.5565 25.4419 47.5275C25.5813 47.4889 25.5452 47.5687 25.5372 47.6784C25.5187 47.9256 25.4128 48.18 25.3475 48.4185C25.2769 48.6789 25.2054 48.9394 25.134 49.1998C24.9813 49.7584 24.8296 50.317 24.6769 50.8747C24.6081 51.1282 24.9434 51.2457 25.0846 51.0457C25.6457 50.2512 25.9255 49.5778 26.6172 49.0464C26.6022 49.2209 26.5881 49.3954 26.574 49.5708C26.551 49.8593 26.4955 50.1644 26.5149 50.4529C26.5484 50.9247 26.9066 51.2518 27.3575 51.0457C27.5931 50.937 27.7625 50.773 27.7625 50.773L27.789 50.7537L27.8843 50.6827L28.0581 50.5687L28.2937 50.4073L28.5557 50.2127L28.8452 50.0092L29.1857 49.7716L29.5316 49.5181L29.8766 49.2656L30.2225 49.0122L30.5587 48.7578L30.8746 48.5202L31.1657 48.2843L31.4207 48.0879L31.6237 47.9002L31.7816 47.7494L31.7878 47.7406L31.7913 47.7441L32.8669 46.4814L35.6154 42.8281H40.4949L44.2907 56.1126H16.4587ZM36.0487 42.2528L44.6922 30.7651L45.5737 29.6102C45.6646 29.4866 45.6513 29.3735 45.5649 29.3112L43.1181 27.5495C43.0325 27.4872 42.9205 27.5118 42.8569 27.5968C42.851 27.605 42.7319 27.7567 42.4996 28.0519L31.8231 42.2528H20.0657L15.6602 56.6879H45.0769L40.921 42.2528H36.0487Z"
                fill="#005DA1"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M46.6821 30.1526L46.3592 29.9114C46.2947 29.8632 46.2021 29.8763 46.1536 29.9404L42.0453 35.3738C41.9959 35.4369 42.01 35.529 42.0736 35.5772L42.3974 35.8184C42.4618 35.8666 42.5527 35.8534 42.6021 35.7894L46.7112 30.356C46.7598 30.292 46.7465 30.2008 46.6821 30.1526Z"
                fill="#0062A5"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M30.178 53.2862H38.353L38.1792 52.6426H30.178H22.1768L22.0039 53.2862H30.178Z"
                fill="#005DA1"
            />
        </svg>
    );
};
